function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgSettingsIcon = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.62
    }
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 5,
    style: {
      fill: "#787878"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M30.31,76.44a11.16,11.16,0,0,0,1.11-1.91l3.19,0,.26-1,.26-1-2.75-1.63a11.55,11.55,0,0,0,0-2.2l2.75-1.63-.26-1-.26-1-3.19,0a10.44,10.44,0,0,0-1.11-1.91l1.57-2.79-.71-.71-.7-.71-2.79,1.57a11.79,11.79,0,0,0-1.91-1.1l0-3.2-1-.26-1-.26-1.63,2.76a11.55,11.55,0,0,0-2.2,0l-1.63-2.76-1,.26-1,.26,0,3.2a11.3,11.3,0,0,0-1.9,1.1L11.67,59l-.71.71-.71.71,1.57,2.79a11,11,0,0,0-1.1,1.91l-3.2,0-.26,1L7,67.1l2.76,1.63a11.55,11.55,0,0,0,0,2.2L7,72.56l.26,1,.26,1,3.2,0a11.79,11.79,0,0,0,1.1,1.91l-1.57,2.79.71.71.71.7,2.79-1.56a11.3,11.3,0,0,0,1.9,1.1l0,3.2,1,.26,1,.25L20,81.14a11.55,11.55,0,0,0,2.2,0l1.63,2.75,1-.25,1-.26,0-3.2a11.79,11.79,0,0,0,1.91-1.1l2.79,1.56.7-.7.71-.71ZM15,75.86a8.53,8.53,0,1,1,12.06,0A8.53,8.53,0,0,1,15,75.86Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.18,43a24.58,24.58,0,0,0-1.27-4.71l5-5.07-1.11-1.92-1.11-1.93-6.88,1.77a25.49,25.49,0,0,0-3.44-3.45l1.76-6.87L76.17,19.7l-1.93-1.11-5.06,4.95a25.63,25.63,0,0,0-4.72-1.26l-1.9-6.82H58.11l-1.9,6.82a25.63,25.63,0,0,0-4.72,1.26l-5.06-4.95L44.5,19.7l-1.92,1.11,1.76,6.87a25.49,25.49,0,0,0-3.44,3.45L34,29.36l-1.11,1.93L31.8,33.21l5,5.07A24.56,24.56,0,0,0,35.5,43L28.67,44.9v4.44l6.83,1.91A24.56,24.56,0,0,0,36.76,56L31.8,61,32.91,63,34,64.88l6.88-1.77a25.49,25.49,0,0,0,3.44,3.45l-1.76,6.87,1.92,1.11,1.93,1.11,5.06-5A25.63,25.63,0,0,0,56.21,72l1.9,6.82h4.45L64.46,72a25.63,25.63,0,0,0,4.72-1.26l5.06,5,1.93-1.11,1.92-1.11-1.76-6.87a25.49,25.49,0,0,0,3.44-3.45l6.88,1.77L87.76,63,88.87,61l-5-5.07a24.58,24.58,0,0,0,1.27-4.71L92,49.34V44.9ZM60.34,66A18.89,18.89,0,1,1,79.22,47.12,18.89,18.89,0,0,1,60.34,66Z",
    style: {
      fill: "#fff",
      stroke: "#757576",
      strokeMiterlimit: 10
    }
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSettingsIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/settings-icon.e5f546fe.svg";
export { ForwardRef as ReactComponent };